module.exports = __webpack_public_path__ + "static/media/them_arrow.8f88e75e.svg";